// src/containers/scroll/index.js
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons';
import './scroll.scss';

export default function Scroll() {
  const [showClass, setShowClass] = useState(false);

  useEffect(() => {
    // busline's version never removed this listener, so every remount
    // stacked another one. Cleanup added.
    const onScroll = () => setShowClass(window.scrollY >= 250);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  };

  return (
    <div className="scroll-to-top">
      <button
        type="button"
        id="bottom-to-top"
        onClick={scrollTop}
        title="Back to top"
        aria-label="Back to top"
        className={showClass ? 'show' : ''}
      >
        <span className="scroll-icon-link">
          <FontAwesomeIcon icon={faCaretUp} />
        </span>
      </button>
    </div>
  );
}
